import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-buy-now-button',
  templateUrl: './buy-now-button.component.html',
  styleUrls: ['./buy-now-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyNowButtonComponent {
  /** Button label (e.g. "Buy Now"). */
  @Input() label = 'Buy Now';

  /** When true, the button is disabled and does not emit clicks. */
  @Input() disabled = false;

  /** Type of the underlying button: 'button' or 'submit'. */
  @Input() type: 'button' | 'submit' = 'button';

  /** Emitted when the button is clicked (not emitted when disabled). */
  @Output() buyNow = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.buyNow.emit(event);
  }
}
